import { actions } from '../constants/exam';
import * as actionTypes from '../../models/action/exam';
import { IAction } from '../../models/action/core';

import { Log } from 'ng2-logger';
import { IGetExamMessagesParamModel, ISetExamMessagesModel } from '../../models/action/exam';

const _logger = Log.create('Exam Add Page');
export function addExamGetAction(data: actionTypes.IExamData, spinnerId?: string, spinnerType?: 'get'|'set', callback?: (value: boolean) => void): actionTypes.IGetAddExam {
    return {
        examData: data,
        timestamp: Date.now(),
        type: actions.ADD_EXAM_ACTIVITY,
        spinnerId,
        spinnerType,
        callback
    };
}

export function addExamSetAction(
    examData: actionTypes.IExamData[] | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.ISetAddExam {
    return {
        examData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_EXAM_SET_ACTIVITY
    };
}

export function setExamDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_DATA_DEFAULT
    };
}

export function updateExamGetAction(
    dataParams: actionTypes.IExamParams,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IUpdateExamGet {
    return {
        ...dataParams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_EXAM_UPDATE_ACTIVITY
    };
}

export function getMyExamsGetAction(
    Filters: actionTypes.IFilters,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IGetMyExams {
    return {
        Filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_MY_EXAMS
    };
}

export function getMyExamsSetAction(
    MyExams: actionTypes.IMyExams[] | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    isLastActivity?: boolean
): actionTypes.ISetMyExams {
    return {
        MyExams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_MY_EXAMS,
        isLastActivity
    };
}

export function getExamMessages(
    getExamMessagesParamModel: IGetExamMessagesParamModel,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
): actionTypes.IGetExamMessages {
    return {
        getExamMessagesParamModel,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_MESSAGES
    };
}

export function setExamMessages(
    setExamMessagesModel: ISetExamMessagesModel,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
): actionTypes.ISetExamMessages {
    return {
        setExamMessagesModel,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_MESSAGES
    };
}
